import React from 'react';
import { getPartyById, getCandidateById, getElectionById } from '../../selectors';
import { getTranslator } from '../../Translator';
import { useAppSelector } from '../../hooks';

type ElectionNameAndCandidateNameProps = {
    candidateId: number;
}

export const ElectionNameAndCandidateName = (props: ElectionNameAndCandidateNameProps) => {
    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const elections = useAppSelector(state => state.elections);
    const language = useAppSelector(state => state.language);

    const t = getTranslator(language);

    const isCandidateAddCandidateSystem = props.candidateId == 0;

    const candidate = getCandidateById(candidates, props.candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    const election = getElectionById(elections, candidate.ElectionId);

    const partyName = !election.CandidateSystem ? t.translate(party.Name) : t['Not applicable'];
    const electionName = t.translate(election.Name);
    const candidateName = candidate.Name;
    const candidateSystem = election.CandidateSystem;

    return <div className="candidate__table">
        <label className="candidate__info__caption">
            {t['Election']}
        </label>
        <div className="candidate__info__value">
            {electionName}
        </div>
        {!candidateSystem && <>
            <label className="candidate__info__caption">
                {t['Party']}
            </label>
            <div className="candidate__info__value">
                {partyName}
            </div></>
        }
        {!isCandidateAddCandidateSystem && <>
            <label className="candidate__info__caption">{t['Candidate']}</label>
            <div className="candidate__info__value">{candidateName}</div>
        </>}
        <div style={{ clear: 'both' }}></div>
    </div>
}
